module.exports = __webpack_public_path__ + "static/media/baby-branco.076f372e.webp";